"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * BxSlider v4.1.2 - Fully loaded, responsive content slider
 * http://bxslider.com
 *
 * Copyright 2014, Steven Wanderski - http://stevenwanderski.com - http://bxcreative.com
 * Written while drinking Belgian ales and listening to jazz
 *
 * Released under the MIT license - http://opensource.org/licenses/MIT
 */

;
(function ($) {
  var plugin = {};
  var defaults = {
    // GENERAL
    mode: 'horizontal',
    slideSelector: '',
    infiniteLoop: true,
    hideControlOnEnd: false,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: false,
    captions: false,
    ticker: false,
    tickerHover: false,
    adaptiveHeight: false,
    adaptiveHeightSpeed: 500,
    video: false,
    useCSS: true,
    preloadImages: 'visible',
    responsive: true,
    slideZIndex: 50,
    wrapperClass: 'bx-wrapper',
    // TOUCH
    touchEnabled: true,
    swipeThreshold: 50,
    oneToOneTouch: true,
    preventDefaultSwipeX: true,
    preventDefaultSwipeY: false,
    // PAGER
    pager: true,
    pagerType: 'full',
    pagerShortSeparator: ' / ',
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,
    // CONTROLS
    controls: true,
    nextText: 'Next',
    prevText: 'Prev',
    nextSelector: null,
    prevSelector: null,
    autoControls: false,
    startText: 'Start',
    stopText: 'Stop',
    autoControlsCombine: false,
    autoControlsSelector: null,
    // AUTO
    auto: false,
    //pause: 4000,
    pause: 8000,
    autoStart: true,
    autoDirection: 'next',
    autoHover: false,
    autoDelay: 0,
    autoSlideForOnePage: false,
    // CAROUSEL
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    // CALLBACKS
    onSliderLoad: function onSliderLoad() {},
    onSlideBefore: function onSlideBefore() {},
    onSlideAfter: function onSlideAfter() {},
    onSlideNext: function onSlideNext() {},
    onSlidePrev: function onSlidePrev() {},
    onSliderResize: function onSliderResize() {}
  };
  $.fn.bxSlider = function (options) {
    if (this.length == 0) return this;

    // support mutltiple elements
    if (this.length > 1) {
      this.each(function () {
        $(this).bxSlider(options);
      });
      return this;
    }

    // create a namespace to be used throughout the plugin
    var slider = {};
    // set a reference to our slider element
    var el = this;
    plugin.el = this;

    /**
     * Makes slideshow responsive
     */
    // first get the original window dimens (thanks alot IE)
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();

    /**
     * ===================================================================================
     * = PRIVATE FUNCTIONS
     * ===================================================================================
     */

    /**
     * Initializes namespace settings to be used throughout plugin
     */
    var init = function init() {
      // merge user-supplied options with the defaults
      slider.settings = $.extend({}, defaults, options);
      // parse slideWidth setting
      slider.settings.slideWidth = parseInt(slider.settings.slideWidth);
      // store the original children
      slider.children = el.children(slider.settings.slideSelector);
      // check if actual number of slides is less than minSlides / maxSlides
      if (slider.children.length < slider.settings.minSlides) slider.settings.minSlides = slider.children.length;
      if (slider.children.length < slider.settings.maxSlides) slider.settings.maxSlides = slider.children.length;
      // if random start, set the startSlide setting to random number
      if (slider.settings.randomStart) slider.settings.startSlide = Math.floor(Math.random() * slider.children.length);
      // store active slide information
      slider.active = {
        index: slider.settings.startSlide
      };
      // store if the slider is in carousel mode (displaying / moving multiple slides)
      slider.carousel = slider.settings.minSlides > 1 || slider.settings.maxSlides > 1;
      // if carousel, force preloadImages = 'all'
      if (slider.carousel) slider.settings.preloadImages = 'all';
      // calculate the min / max width thresholds based on min / max number of slides
      // used to setup and update carousel slides dimensions
      slider.minThreshold = slider.settings.minSlides * slider.settings.slideWidth + (slider.settings.minSlides - 1) * slider.settings.slideMargin;
      slider.maxThreshold = slider.settings.maxSlides * slider.settings.slideWidth + (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
      // store the current state of the slider (if currently animating, working is true)
      slider.working = false;
      // initialize the controls object
      slider.controls = {};
      // initialize an auto interval
      slider.interval = null;
      // determine which property to use for transitions
      slider.animProp = slider.settings.mode == 'vertical' ? 'top' : 'left';
      // determine if hardware acceleration can be used
      slider.usingCSS = slider.settings.useCSS && slider.settings.mode != 'fade' && function () {
        // create our test div element
        var div = document.createElement('div');
        // css transition properties
        var props = ['WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
        // test for each property
        for (var i in props) {
          if (div.style[props[i]] !== undefined) {
            slider.cssPrefix = props[i].replace('Perspective', '').toLowerCase();
            slider.animProp = '-' + slider.cssPrefix + '-transform';
            return true;
          }
        }
        return false;
      }();
      // if vertical mode always make maxSlides and minSlides equal
      if (slider.settings.mode == 'vertical') slider.settings.maxSlides = slider.settings.minSlides;
      // save original style data
      el.data("origStyle", el.attr("style"));
      el.children(slider.settings.slideSelector).each(function () {
        $(this).data("origStyle", $(this).attr("style"));
      });
      // perform all DOM / CSS modifications
      setup();
    };

    /**
     * Performs all DOM and CSS modifications
     */
    var setup = function setup() {
      // wrap el in a wrapper
      el.wrap('<div class="' + slider.settings.wrapperClass + '"><div class="bx-viewport"></div></div>');
      // store a namspace reference to .bx-viewport
      slider.viewport = el.parent();
      // add a loading div to display while images are loading
      slider.loader = $('<div class="bx-loading" />');
      slider.viewport.prepend(slider.loader);
      // set el to a massive width, to hold any needed slides
      // also strip any margin and padding from el
      el.css({
        width: slider.settings.mode == 'horizontal' ? slider.children.length * 100 + 215 + '%' : 'auto',
        position: 'relative'
      });
      // if using CSS, add the easing property
      if (slider.usingCSS && slider.settings.easing) {
        el.css('-' + slider.cssPrefix + '-transition-timing-function', slider.settings.easing);
        // if not using CSS and no easing value was supplied, use the default JS animation easing (swing)
      } else if (!slider.settings.easing) {
        slider.settings.easing = 'swing';
      }
      var slidesShowing = getNumberSlidesShowing();
      // make modifications to the viewport (.bx-viewport)
      slider.viewport.css({
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      });
      slider.viewport.parent().css({
        maxWidth: getViewportMaxWidth()
      });
      // make modification to the wrapper (.bx-wrapper)
      if (!slider.settings.pager) {
        slider.viewport.parent().css({
          margin: '0 auto 0px'
        });
      }
      // apply css to all slider children
      slider.children.css({
        'float': slider.settings.mode == 'horizontal' ? 'left' : 'none',
        listStyle: 'none',
        position: 'relative'
      });
      // apply the calculated width after the float is applied to prevent scrollbar interference
      slider.children.css('width', getSlideWidth());
      // if slideMargin is supplied, add the css
      if (slider.settings.mode == 'horizontal' && slider.settings.slideMargin > 0) slider.children.css('marginRight', slider.settings.slideMargin);
      if (slider.settings.mode == 'vertical' && slider.settings.slideMargin > 0) slider.children.css('marginBottom', slider.settings.slideMargin);
      // if "fade" mode, add positioning and z-index CSS
      if (slider.settings.mode == 'fade') {
        slider.children.css({
          position: 'absolute',
          zIndex: 0,
          display: 'none'
        });
        // prepare the z-index on the showing element
        slider.children.eq(slider.settings.startSlide).css({
          zIndex: slider.settings.slideZIndex,
          display: 'block'
        });
      }
      // create an element to contain all slider controls (pager, start / stop, etc)
      slider.controls.el = $('<div class="bx-controls" />');
      // if captions are requested, add them
      if (slider.settings.captions) appendCaptions();
      // check if startSlide is last slide
      slider.active.last = slider.settings.startSlide == getPagerQty() - 1;
      // if video is true, set up the fitVids plugin
      if (slider.settings.video) el.fitVids();
      // set the default preload selector (visible)
      var preloadSelector = slider.children.eq(slider.settings.startSlide);
      if (slider.settings.preloadImages == "all") preloadSelector = slider.children;
      // only check for control addition if not in "ticker" mode
      if (!slider.settings.ticker) {
        // if pager is requested, add it
        if (slider.settings.pager) appendPager();
        // if controls are requested, add them
        if (slider.settings.controls) appendControls();
        // if auto is true, and auto controls are requested, add them
        if (slider.settings.auto && slider.settings.autoControls) appendControlsAuto();
        // if any control option is requested, add the controls wrapper
        if (slider.settings.controls || slider.settings.autoControls || slider.settings.pager) slider.viewport.after(slider.controls.el);
        // if ticker mode, do not allow a pager
      } else {
        slider.settings.pager = false;
      }
      // preload all images, then perform final DOM / CSS modifications that depend on images being loaded
      loadElements(preloadSelector, start);
    };
    var loadElements = function loadElements(selector, callback) {
      var total = selector.find('img, iframe').length;
      if (total == 0) {
        callback();
        return;
      }
      var count = 0;
      selector.find('img, iframe').each(function () {
        $(this).one('load', function () {
          if (++count == total) callback();
        }).each(function () {
          if (this.complete) $(this).load();
        });
      });
    };

    /**
     * Start the slider
     */
    var start = function start() {
      // if infinite loop, prepare additional slides
      if (slider.settings.infiniteLoop && slider.settings.mode != 'fade' && !slider.settings.ticker) {
        var slice = slider.settings.mode == 'vertical' ? slider.settings.minSlides : slider.settings.maxSlides;
        var sliceAppend = slider.children.slice(0, slice).clone().addClass('bx-clone');
        var slicePrepend = slider.children.slice(-slice).clone().addClass('bx-clone');
        el.append(sliceAppend).prepend(slicePrepend);
      }
      // remove the loading DOM element
      slider.loader.remove();
      // set the left / top position of "el"
      setSlidePosition();
      // if "vertical" mode, always use adaptiveHeight to prevent odd behavior
      if (slider.settings.mode == 'vertical') slider.settings.adaptiveHeight = true;
      // set the viewport height
      slider.viewport.height(getViewportHeight());
      // make sure everything is positioned just right (same as a window resize)
      el.redrawSlider();
      // onSliderLoad callback
      slider.settings.onSliderLoad(slider.active.index);
      // slider has been fully initialized
      slider.initialized = true;
      // bind the resize call to the window
      if (slider.settings.responsive) $(window).bind('resize', resizeWindow);
      // if auto is true and has more than 1 page, start the show
      if (slider.settings.auto && slider.settings.autoStart && (getPagerQty() > 1 || slider.settings.autoSlideForOnePage)) initAuto();
      // if ticker is true, start the ticker
      if (slider.settings.ticker) initTicker();
      // if pager is requested, make the appropriate pager link active
      if (slider.settings.pager) updatePagerActive(slider.settings.startSlide);
      // check for any updates to the controls (like hideControlOnEnd updates)
      if (slider.settings.controls) updateDirectionControls();
      // if touchEnabled is true, setup the touch events
      if (slider.settings.touchEnabled && !slider.settings.ticker) initTouch();
    };

    /**
     * Returns the calculated height of the viewport, used to determine either adaptiveHeight or the maxHeight value
     */
    var getViewportHeight = function getViewportHeight() {
      var height = 0;
      // first determine which children (slides) should be used in our height calculation
      var children = $();
      // if mode is not "vertical" and adaptiveHeight is false, include all children
      if (slider.settings.mode != 'vertical' && !slider.settings.adaptiveHeight) {
        children = slider.children;
      } else {
        // if not carousel, return the single active child
        if (!slider.carousel) {
          children = slider.children.eq(slider.active.index);
          // if carousel, return a slice of children
        } else {
          // get the individual slide index
          var currentIndex = slider.settings.moveSlides == 1 ? slider.active.index : slider.active.index * getMoveBy();
          // add the current slide to the children
          children = slider.children.eq(currentIndex);
          // cycle through the remaining "showing" slides
          for (i = 1; i <= slider.settings.maxSlides - 1; i++) {
            // if looped back to the start
            if (currentIndex + i >= slider.children.length) {
              children = children.add(slider.children.eq(i - 1));
            } else {
              children = children.add(slider.children.eq(currentIndex + i));
            }
          }
        }
      }
      // if "vertical" mode, calculate the sum of the heights of the children
      if (slider.settings.mode == 'vertical') {
        children.each(function (index) {
          height += $(this).outerHeight();
        });
        // add user-supplied margins
        if (slider.settings.slideMargin > 0) {
          height += slider.settings.slideMargin * (slider.settings.minSlides - 1);
        }
        // if not "vertical" mode, calculate the max height of the children
      } else {
        height = Math.max.apply(Math, children.map(function () {
          return $(this).outerHeight(false);
        }).get());
      }
      if (slider.viewport.css('box-sizing') == 'border-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom')) + parseFloat(slider.viewport.css('border-top-width')) + parseFloat(slider.viewport.css('border-bottom-width'));
      } else if (slider.viewport.css('box-sizing') == 'padding-box') {
        height += parseFloat(slider.viewport.css('padding-top')) + parseFloat(slider.viewport.css('padding-bottom'));
      }
      return height;
    };

    /**
     * Returns the calculated width to be used for the outer wrapper / viewport
     */
    var getViewportMaxWidth = function getViewportMaxWidth() {
      var width = '100%';
      if (slider.settings.slideWidth > 0) {
        if (slider.settings.mode == 'horizontal') {
          width = slider.settings.maxSlides * slider.settings.slideWidth + (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
        } else {
          width = slider.settings.slideWidth;
        }
      }
      return width;
    };

    /**
     * Returns the calculated width to be applied to each slide
     */
    var getSlideWidth = function getSlideWidth() {
      // start with any user-supplied slide width
      var newElWidth = slider.settings.slideWidth;
      // get the current viewport width
      var wrapWidth = slider.viewport.width();
      // if slide width was not supplied, or is larger than the viewport use the viewport width
      if (slider.settings.slideWidth == 0 || slider.settings.slideWidth > wrapWidth && !slider.carousel || slider.settings.mode == 'vertical') {
        newElWidth = wrapWidth;
        // if carousel, use the thresholds to determine the width
      } else if (slider.settings.maxSlides > 1 && slider.settings.mode == 'horizontal') {
        if (wrapWidth > slider.maxThreshold) {
          // newElWidth = (wrapWidth - (slider.settings.slideMargin * (slider.settings.maxSlides - 1))) / slider.settings.maxSlides;
        } else if (wrapWidth < slider.minThreshold) {
          newElWidth = (wrapWidth - slider.settings.slideMargin * (slider.settings.minSlides - 1)) / slider.settings.minSlides;
        }
      }
      return newElWidth;
    };

    /**
     * Returns the number of slides currently visible in the viewport (includes partially visible slides)
     */
    var getNumberSlidesShowing = function getNumberSlidesShowing() {
      var slidesShowing = 1;
      if (slider.settings.mode == 'horizontal' && slider.settings.slideWidth > 0) {
        // if viewport is smaller than minThreshold, return minSlides
        if (slider.viewport.width() < slider.minThreshold) {
          slidesShowing = slider.settings.minSlides;
          // if viewport is larger than minThreshold, return maxSlides
        } else if (slider.viewport.width() > slider.maxThreshold) {
          slidesShowing = slider.settings.maxSlides;
          // if viewport is between min / max thresholds, divide viewport width by first child width
        } else {
          var childWidth = slider.children.first().width() + slider.settings.slideMargin;
          slidesShowing = Math.floor((slider.viewport.width() + slider.settings.slideMargin) / childWidth);
        }
        // if "vertical" mode, slides showing will always be minSlides
      } else if (slider.settings.mode == 'vertical') {
        slidesShowing = slider.settings.minSlides;
      }
      return slidesShowing;
    };

    /**
     * Returns the number of pages (one full viewport of slides is one "page")
     */
    var getPagerQty = function getPagerQty() {
      var pagerQty = 0;
      // if moveSlides is specified by the user
      if (slider.settings.moveSlides > 0) {
        if (slider.settings.infiniteLoop) {
          pagerQty = Math.ceil(slider.children.length / getMoveBy());
        } else {
          // use a while loop to determine pages
          var breakPoint = 0;
          var counter = 0;
          // when breakpoint goes above children length, counter is the number of pages
          while (breakPoint < slider.children.length) {
            ++pagerQty;
            breakPoint = counter + getNumberSlidesShowing();
            counter += slider.settings.moveSlides <= getNumberSlidesShowing() ? slider.settings.moveSlides : getNumberSlidesShowing();
          }
        }
        // if moveSlides is 0 (auto) divide children length by sides showing, then round up
      } else {
        pagerQty = Math.ceil(slider.children.length / getNumberSlidesShowing());
      }
      return pagerQty;
    };

    /**
     * Returns the number of indivual slides by which to shift the slider
     */
    var getMoveBy = function getMoveBy() {
      // if moveSlides was set by the user and moveSlides is less than number of slides showing
      if (slider.settings.moveSlides > 0 && slider.settings.moveSlides <= getNumberSlidesShowing()) {
        return slider.settings.moveSlides;
      }
      // if moveSlides is 0 (auto)
      return getNumberSlidesShowing();
    };

    /**
     * Sets the slider's (el) left or top position
     */
    var setSlidePosition = function setSlidePosition() {
      // if last slide, not infinite loop, and number of children is larger than specified maxSlides
      if (slider.children.length > slider.settings.maxSlides && slider.active.last && !slider.settings.infiniteLoop) {
        if (slider.settings.mode == 'horizontal') {
          // get the last child's position
          var lastChild = slider.children.last();
          var position = lastChild.position();
          // set the left position
          _setPositionProperty(-(position.left - (slider.viewport.width() - lastChild.outerWidth())), 'reset', 0);
        } else if (slider.settings.mode == 'vertical') {
          // get the last showing index's position
          var lastShowingIndex = slider.children.length - slider.settings.minSlides;
          var position = slider.children.eq(lastShowingIndex).position();
          // set the top position
          _setPositionProperty(-position.top, 'reset', 0);
        }
        // if not last slide
      } else {
        // get the position of the first showing slide
        var position = slider.children.eq(slider.active.index * getMoveBy()).position();
        // check for last slide
        if (slider.active.index == getPagerQty() - 1) slider.active.last = true;
        // set the repective position
        if (position != undefined) {
          if (slider.settings.mode == 'horizontal') _setPositionProperty(-position.left, 'reset', 0);else if (slider.settings.mode == 'vertical') _setPositionProperty(-position.top, 'reset', 0);
        }
      }
    };

    /**
     * Sets the el's animating property position (which in turn will sometimes animate el).
     * If using CSS, sets the transform property. If not using CSS, sets the top / left property.
     *
     * @param value (int)
     *  - the animating property's value
     *
     * @param type (string) 'slider', 'reset', 'ticker'
     *  - the type of instance for which the function is being
     *
     * @param duration (int)
     *  - the amount of time (in ms) the transition should occupy
     *
     * @param params (array) optional
     *  - an optional parameter containing any variables that need to be passed in
     */
    var _setPositionProperty = function setPositionProperty(value, type, duration, params) {
      // use CSS transform
      if (slider.usingCSS) {
        // determine the translate3d value
        var propValue = slider.settings.mode == 'vertical' ? 'translate3d(0, ' + value + 'px, 0)' : 'translate3d(' + value + 'px, 0, 0)';
        // add the CSS transition-duration
        el.css('-' + slider.cssPrefix + '-transition-duration', duration / 1000 + 's');
        if (type == 'slide') {
          // set the property value
          el.css(slider.animProp, propValue);
          // bind a callback method - executes when CSS transition completes
          el.bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
            // unbind the callback
            el.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
            updateAfterSlideTransition();
          });
        } else if (type == 'reset') {
          el.css(slider.animProp, propValue);
        } else if (type == 'ticker') {
          // make the transition use 'linear'
          el.css('-' + slider.cssPrefix + '-transition-timing-function', 'linear');
          el.css(slider.animProp, propValue);
          // bind a callback method - executes when CSS transition completes
          el.bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
            // unbind the callback
            el.unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd');
            // reset the position
            _setPositionProperty(params['resetValue'], 'reset', 0);
            // start the loop again
            tickerLoop();
          });
        }
        // use JS animate
      } else {
        var animateObj = {};
        animateObj[slider.animProp] = value;
        if (type == 'slide') {
          el.animate(animateObj, duration, slider.settings.easing, function () {
            updateAfterSlideTransition();
          });
        } else if (type == 'reset') {
          el.css(slider.animProp, value);
        } else if (type == 'ticker') {
          el.animate(animateObj, speed, 'linear', function () {
            _setPositionProperty(params['resetValue'], 'reset', 0);
            // run the recursive loop after animation
            tickerLoop();
          });
        }
      }
    };

    /**
     * Populates the pager with proper amount of pages
     */
    var populatePager = function populatePager() {
      var pagerHtml = '';
      var pagerQty = getPagerQty();
      // loop through each pager item
      for (var i = 0; i < pagerQty; i++) {
        var linkContent = '';
        // if a buildPager function is supplied, use it to get pager link value, else use index + 1
        if (slider.settings.buildPager && $.isFunction(slider.settings.buildPager)) {
          linkContent = slider.settings.buildPager(i);
          slider.pagerEl.addClass('bx-custom-pager');
        } else {
          linkContent = i + 1;
          slider.pagerEl.addClass('bx-default-pager');
        }
        // var linkContent = slider.settings.buildPager && $.isFunction(slider.settings.buildPager) ? slider.settings.buildPager(i) : i + 1;
        // add the markup to the string
        pagerHtml += '<div class="bx-pager-item"><a href="" data-slide-index="' + i + '" class="bx-pager-link">' + linkContent + '</a></div>';
      }
      ;
      // populate the pager element with pager links
      slider.pagerEl.html(pagerHtml);
    };

    /**
     * Appends the pager to the controls element
     */
    var appendPager = function appendPager() {
      if (!slider.settings.pagerCustom) {
        // create the pager DOM element
        slider.pagerEl = $('<div class="bx-pager" />');
        // if a pager selector was supplied, populate it with the pager
        if (slider.settings.pagerSelector) {
          $(slider.settings.pagerSelector).html(slider.pagerEl);
          // if no pager selector was supplied, add it after the wrapper
        } else {
          slider.controls.el.addClass('bx-has-pager').append(slider.pagerEl);
        }
        // populate the pager
        populatePager();
      } else {
        slider.pagerEl = $(slider.settings.pagerCustom);
      }
      // assign the pager click binding
      slider.pagerEl.on('click', 'a', clickPagerBind);
    };

    /**
     * Appends prev / next controls to the controls element
     */
    var appendControls = function appendControls() {
      slider.controls.next = $('<a class="bx-next" href="">' + slider.settings.nextText + '</a>');
      slider.controls.prev = $('<a class="bx-prev" href="">' + slider.settings.prevText + '</a>');
      // bind click actions to the controls
      slider.controls.next.bind('click', clickNextBind);
      slider.controls.prev.bind('click', clickPrevBind);
      // if nextSlector was supplied, populate it
      if (slider.settings.nextSelector) {
        $(slider.settings.nextSelector).append(slider.controls.next);
      }
      // if prevSlector was supplied, populate it
      if (slider.settings.prevSelector) {
        $(slider.settings.prevSelector).append(slider.controls.prev);
      }
      // if no custom selectors were supplied
      if (!slider.settings.nextSelector && !slider.settings.prevSelector) {
        // add the controls to the DOM
        slider.controls.directionEl = $('<div class="bx-controls-direction" />');
        // add the control elements to the directionEl
        slider.controls.directionEl.append(slider.controls.prev).append(slider.controls.next);
        // slider.viewport.append(slider.controls.directionEl);
        slider.controls.el.addClass('bx-has-controls-direction').append(slider.controls.directionEl);
      }
    };

    /**
     * Appends start / stop auto controls to the controls element
     */
    var appendControlsAuto = function appendControlsAuto() {
      slider.controls.start = $('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + slider.settings.startText + '</a></div>');
      slider.controls.stop = $('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + slider.settings.stopText + '</a></div>');
      // add the controls to the DOM
      slider.controls.autoEl = $('<div class="bx-controls-auto" />');
      // bind click actions to the controls
      slider.controls.autoEl.on('click', '.bx-start', clickStartBind);
      slider.controls.autoEl.on('click', '.bx-stop', clickStopBind);
      // if autoControlsCombine, insert only the "start" control
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.append(slider.controls.start);
        // if autoControlsCombine is false, insert both controls
      } else {
        slider.controls.autoEl.append(slider.controls.start).append(slider.controls.stop);
      }
      // if auto controls selector was supplied, populate it with the controls
      if (slider.settings.autoControlsSelector) {
        $(slider.settings.autoControlsSelector).html(slider.controls.autoEl);
        // if auto controls selector was not supplied, add it after the wrapper
      } else {
        slider.controls.el.addClass('bx-has-controls-auto').append(slider.controls.autoEl);
      }
      // update the auto controls
      updateAutoControls(slider.settings.autoStart ? 'stop' : 'start');
    };

    /**
     * Appends image captions to the DOM
     */
    var appendCaptions = function appendCaptions() {
      // cycle through each child
      slider.children.each(function (index) {
        // get the image title attribute
        var title = $(this).find('img:first').attr('title');
        // append the caption
        if (title != undefined && ('' + title).length) {
          $(this).append('<div class="bx-caption"><span>' + title + '</span></div>');
        }
      });
    };

    /**
     * Click next binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickNextBind = function clickNextBind(e) {
      // if auto show is running, stop it
      if (slider.settings.auto) el.stopAuto();
      el.goToNextSlide();
      e.preventDefault();
    };

    /**
     * Click prev binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPrevBind = function clickPrevBind(e) {
      // if auto show is running, stop it
      if (slider.settings.auto) el.stopAuto();
      el.goToPrevSlide();
      e.preventDefault();
    };

    /**
     * Click start binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStartBind = function clickStartBind(e) {
      el.startAuto();
      e.preventDefault();
    };

    /**
     * Click stop binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStopBind = function clickStopBind(e) {
      el.stopAuto();
      e.preventDefault();
    };

    /**
     * Click pager binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPagerBind = function clickPagerBind(e) {
      // if auto show is running, stop it
      if (slider.settings.auto) el.stopAuto();
      var pagerLink = $(e.currentTarget);
      if (pagerLink.attr('data-slide-index') !== undefined) {
        var pagerIndex = parseInt(pagerLink.attr('data-slide-index'));
        // if clicked pager link is not active, continue with the goToSlide call
        if (pagerIndex != slider.active.index) el.goToSlide(pagerIndex);
        e.preventDefault();
      }
    };

    /**
     * Updates the pager links with an active class
     *
     * @param slideIndex (int)
     *  - index of slide to make active
     */
    var updatePagerActive = function updatePagerActive(slideIndex) {
      // if "short" pager type
      var len = slider.children.length; // nb of children
      if (slider.settings.pagerType == 'short') {
        if (slider.settings.maxSlides > 1) {
          len = Math.ceil(slider.children.length / slider.settings.maxSlides);
        }
        slider.pagerEl.html(slideIndex + 1 + slider.settings.pagerShortSeparator + len);
        return;
      }
      // remove all pager active classes
      slider.pagerEl.find('a').removeClass('active');
      // apply the active class for all pagers
      slider.pagerEl.each(function (i, el) {
        $(el).find('a').eq(slideIndex).addClass('active');
      });
    };

    /**
     * Performs needed actions after a slide transition
     */
    var updateAfterSlideTransition = function updateAfterSlideTransition() {
      // if infinte loop is true
      if (slider.settings.infiniteLoop) {
        var position = '';
        // first slide
        if (slider.active.index == 0) {
          // set the new position
          position = slider.children.eq(0).position();
          // carousel, last slide
        } else if (slider.active.index == getPagerQty() - 1 && slider.carousel) {
          position = slider.children.eq((getPagerQty() - 1) * getMoveBy()).position();
          // last slide
        } else if (slider.active.index == slider.children.length - 1) {
          position = slider.children.eq(slider.children.length - 1).position();
        }
        if (position) {
          if (slider.settings.mode == 'horizontal') {
            _setPositionProperty(-position.left, 'reset', 0);
          } else if (slider.settings.mode == 'vertical') {
            _setPositionProperty(-position.top, 'reset', 0);
          }
        }
      }
      // declare that the transition is complete
      slider.working = false;
      // onSlideAfter callback
      slider.settings.onSlideAfter(slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
    };

    /**
     * Updates the auto controls state (either active, or combined switch)
     *
     * @param state (string) "start", "stop"
     *  - the new state of the auto show
     */
    var updateAutoControls = function updateAutoControls(state) {
      // if autoControlsCombine is true, replace the current control with the new state
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.html(slider.controls[state]);
        // if autoControlsCombine is false, apply the "active" class to the appropriate control
      } else {
        slider.controls.autoEl.find('a').removeClass('active');
        slider.controls.autoEl.find('a:not(.bx-' + state + ')').addClass('active');
      }
    };

    /**
     * Updates the direction controls (checks if either should be hidden)
     */
    var updateDirectionControls = function updateDirectionControls() {
      if (getPagerQty() == 1) {
        slider.controls.prev.addClass('disabled');
        slider.controls.next.addClass('disabled');
      } else if (!slider.settings.infiniteLoop && slider.settings.hideControlOnEnd) {
        // if first slide
        if (slider.active.index == 0) {
          slider.controls.prev.addClass('disabled');
          slider.controls.next.removeClass('disabled');
          // if last slide
        } else if (slider.active.index == getPagerQty() - 1) {
          slider.controls.next.addClass('disabled');
          slider.controls.prev.removeClass('disabled');
          // if any slide in the middle
        } else {
          slider.controls.prev.removeClass('disabled');
          slider.controls.next.removeClass('disabled');
        }
      }
    };

    /**
     * Initialzes the auto process
     */
    var initAuto = function initAuto() {
      // if autoDelay was supplied, launch the auto show using a setTimeout() call
      if (slider.settings.autoDelay > 0) {
        var timeout = setTimeout(el.startAuto, slider.settings.autoDelay);
        // if autoDelay was not supplied, start the auto show normally
      } else {
        el.startAuto();
      }
      // if autoHover is requested
      if (slider.settings.autoHover) {
        // on el hover
        el.hover(function () {
          // if the auto show is currently playing (has an active interval)
          if (slider.interval) {
            // stop the auto show and pass true agument which will prevent control update
            el.stopAuto(true);
            // create a new autoPaused value which will be used by the relative "mouseout" event
            slider.autoPaused = true;
          }
        }, function () {
          // if the autoPaused value was created be the prior "mouseover" event
          if (slider.autoPaused) {
            // start the auto show and pass true agument which will prevent control update
            el.startAuto(true);
            // reset the autoPaused value
            slider.autoPaused = null;
          }
        });
      }
    };

    /**
     * Initialzes the ticker process
     */
    var initTicker = function initTicker() {
      var startPosition = 0;
      // if autoDirection is "next", append a clone of the entire slider
      if (slider.settings.autoDirection == 'next') {
        el.append(slider.children.clone().addClass('bx-clone'));
        // if autoDirection is "prev", prepend a clone of the entire slider, and set the left position
      } else {
        el.prepend(slider.children.clone().addClass('bx-clone'));
        var position = slider.children.first().position();
        startPosition = slider.settings.mode == 'horizontal' ? -position.left : -position.top;
      }
      _setPositionProperty(startPosition, 'reset', 0);
      // do not allow controls in ticker mode
      slider.settings.pager = false;
      slider.settings.controls = false;
      slider.settings.autoControls = false;
      // if autoHover is requested
      if (slider.settings.tickerHover && !slider.usingCSS) {
        // on el hover
        slider.viewport.hover(function () {
          el.stop();
        }, function () {
          // calculate the total width of children (used to calculate the speed ratio)
          var totalDimens = 0;
          slider.children.each(function (index) {
            totalDimens += slider.settings.mode == 'horizontal' ? $(this).outerWidth(true) : $(this).outerHeight(true);
          });
          // calculate the speed ratio (used to determine the new speed to finish the paused animation)
          var ratio = slider.settings.speed / totalDimens;
          // determine which property to use
          var property = slider.settings.mode == 'horizontal' ? 'left' : 'top';
          // calculate the new speed
          var newSpeed = ratio * (totalDimens - Math.abs(parseInt(el.css(property))));
          tickerLoop(newSpeed);
        });
      }
      // start the ticker loop
      tickerLoop();
    };

    /**
     * Runs a continuous loop, news ticker-style
     */
    var tickerLoop = function tickerLoop(resumeSpeed) {
      speed = resumeSpeed ? resumeSpeed : slider.settings.speed;
      var position = {
        left: 0,
        top: 0
      };
      var reset = {
        left: 0,
        top: 0
      };
      // if "next" animate left position to last child, then reset left to 0
      if (slider.settings.autoDirection == 'next') {
        position = el.find('.bx-clone').first().position();
        // if "prev" animate left position to 0, then reset left to first non-clone child
      } else {
        reset = slider.children.first().position();
      }
      var animateProperty = slider.settings.mode == 'horizontal' ? -position.left : -position.top;
      var resetValue = slider.settings.mode == 'horizontal' ? -reset.left : -reset.top;
      var params = {
        resetValue: resetValue
      };
      _setPositionProperty(animateProperty, 'ticker', speed, params);
    };

    /**
     * Initializes touch events
     */
    var initTouch = function initTouch() {
      // initialize object to contain all touch values
      slider.touch = {
        start: {
          x: 0,
          y: 0
        },
        end: {
          x: 0,
          y: 0
        }
      };
      slider.viewport.bind('touchstart', onTouchStart);
    };

    /**
     * Event handler for "touchstart"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchStart = function onTouchStart(e) {
      if (slider.working) {
        e.preventDefault();
      } else {
        // record the original position when touch starts
        slider.touch.originalPos = el.position();
        var orig = e.originalEvent;
        // record the starting touch x, y coordinates
        slider.touch.start.x = orig.changedTouches[0].pageX;
        slider.touch.start.y = orig.changedTouches[0].pageY;
        // bind a "touchmove" event to the viewport
        slider.viewport.bind('touchmove', onTouchMove);
        // bind a "touchend" event to the viewport
        slider.viewport.bind('touchend', _onTouchEnd);
      }
    };

    /**
     * Event handler for "touchmove"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchMove = function onTouchMove(e) {
      var orig = e.originalEvent;
      // if scrolling on y axis, do not prevent default
      var xMovement = Math.abs(orig.changedTouches[0].pageX - slider.touch.start.x);
      var yMovement = Math.abs(orig.changedTouches[0].pageY - slider.touch.start.y);
      // x axis swipe
      if (xMovement * 3 > yMovement && slider.settings.preventDefaultSwipeX) {
        e.preventDefault();
        // y axis swipe
      } else if (yMovement * 3 > xMovement && slider.settings.preventDefaultSwipeY) {
        e.preventDefault();
      }
      if (slider.settings.mode != 'fade' && slider.settings.oneToOneTouch) {
        var value = 0;
        // if horizontal, drag along x axis
        if (slider.settings.mode == 'horizontal') {
          var change = orig.changedTouches[0].pageX - slider.touch.start.x;
          value = slider.touch.originalPos.left + change;
          // if vertical, drag along y axis
        } else {
          var change = orig.changedTouches[0].pageY - slider.touch.start.y;
          value = slider.touch.originalPos.top + change;
        }
        _setPositionProperty(value, 'reset', 0);
      }
    };

    /**
     * Event handler for "touchend"
     *
     * @param e (event)
     *  - DOM event object
     */
    var _onTouchEnd = function onTouchEnd(e) {
      slider.viewport.unbind('touchmove', onTouchMove);
      var orig = e.originalEvent;
      var value = 0;
      // record end x, y positions
      slider.touch.end.x = orig.changedTouches[0].pageX;
      slider.touch.end.y = orig.changedTouches[0].pageY;
      // if fade mode, check if absolute x distance clears the threshold
      if (slider.settings.mode == 'fade') {
        var distance = Math.abs(slider.touch.start.x - slider.touch.end.x);
        if (distance >= slider.settings.swipeThreshold) {
          slider.touch.start.x > slider.touch.end.x ? el.goToNextSlide() : el.goToPrevSlide();
          el.stopAuto();
        }
        // not fade mode
      } else {
        var distance = 0;
        // calculate distance and el's animate property
        if (slider.settings.mode == 'horizontal') {
          distance = slider.touch.end.x - slider.touch.start.x;
          value = slider.touch.originalPos.left;
        } else {
          distance = slider.touch.end.y - slider.touch.start.y;
          value = slider.touch.originalPos.top;
        }
        // if not infinite loop and first / last slide, do not attempt a slide transition
        if (!slider.settings.infiniteLoop && (slider.active.index == 0 && distance > 0 || slider.active.last && distance < 0)) {
          _setPositionProperty(value, 'reset', 200);
        } else {
          // check if distance clears threshold
          if (Math.abs(distance) >= slider.settings.swipeThreshold) {
            distance < 0 ? el.goToNextSlide() : el.goToPrevSlide();
            el.stopAuto();
          } else {
            // el.animate(property, 200);
            _setPositionProperty(value, 'reset', 200);
          }
        }
      }
      slider.viewport.unbind('touchend', _onTouchEnd);
    };

    /**
     * Window resize event callback
     */
    var resizeWindow = function resizeWindow(e) {
      // don't do anything if slider isn't initialized.
      if (!slider.initialized) return;
      // get the new window dimens (again, thank you IE)
      var windowWidthNew = $(window).width();
      var windowHeightNew = $(window).height();
      // make sure that it is a true window resize
      // *we must check this because our dinosaur friend IE fires a window resize event when certain DOM elements
      // are resized. Can you just die already?*
      if (windowWidth != windowWidthNew || windowHeight != windowHeightNew) {
        // set the new window dimens
        windowWidth = windowWidthNew;
        windowHeight = windowHeightNew;
        // update all dynamic elements
        el.redrawSlider();
        // Call user resize handler
        slider.settings.onSliderResize.call(el, slider.active.index);
      }
    };

    /**
     * ===================================================================================
     * = PUBLIC FUNCTIONS
     * ===================================================================================
     */

    /**
     * Performs slide transition to the specified slide
     *
     * @param slideIndex (int)
     *  - the destination slide's index (zero-based)
     *
     * @param direction (string)
     *  - INTERNAL USE ONLY - the direction of travel ("prev" / "next")
     */
    el.goToSlide = function (slideIndex, direction) {
      // if plugin is currently in motion, ignore request
      if (slider.working || slider.active.index == slideIndex) return;
      // declare that plugin is in motion
      slider.working = true;
      // store the old index
      slider.oldIndex = slider.active.index;
      // if slideIndex is less than zero, set active index to last child (this happens during infinite loop)
      if (slideIndex < 0) {
        slider.active.index = getPagerQty() - 1;
        // if slideIndex is greater than children length, set active index to 0 (this happens during infinite loop)
      } else if (slideIndex >= getPagerQty()) {
        slider.active.index = 0;
        // set active index to requested slide
      } else {
        slider.active.index = slideIndex;
      }
      // onSlideBefore, onSlideNext, onSlidePrev callbacks
      slider.settings.onSlideBefore(slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
      if (direction == 'next') {
        slider.settings.onSlideNext(slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
      } else if (direction == 'prev') {
        slider.settings.onSlidePrev(slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
      }
      // check if last slide
      slider.active.last = slider.active.index >= getPagerQty() - 1;
      // update the pager with active class
      if (slider.settings.pager) updatePagerActive(slider.active.index);
      // // check for direction control update
      if (slider.settings.controls) updateDirectionControls();
      // if slider is set to mode: "fade"
      if (slider.settings.mode == 'fade') {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() != getViewportHeight()) {
          slider.viewport.animate({
            height: getViewportHeight()
          }, slider.settings.adaptiveHeightSpeed);
        }
        // fade out the visible child and reset its z-index value
        slider.children.filter(':visible').fadeOut(slider.settings.speed).css({
          zIndex: 0
        });
        // fade in the newly requested slide
        slider.children.eq(slider.active.index).css('zIndex', slider.settings.slideZIndex + 1).fadeIn(slider.settings.speed, function () {
          $(this).css('zIndex', slider.settings.slideZIndex);
          updateAfterSlideTransition();
        });
        // slider mode is not "fade"
      } else {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (slider.settings.adaptiveHeight && slider.viewport.height() != getViewportHeight()) {
          slider.viewport.animate({
            height: getViewportHeight()
          }, slider.settings.adaptiveHeightSpeed);
        }
        var moveBy = 0;
        var position = {
          left: 0,
          top: 0
        };
        // if carousel and not infinite loop
        if (!slider.settings.infiniteLoop && slider.carousel && slider.active.last) {
          if (slider.settings.mode == 'horizontal') {
            // get the last child position
            var lastChild = slider.children.eq(slider.children.length - 1);
            position = lastChild.position();
            // calculate the position of the last slide
            moveBy = slider.viewport.width() - lastChild.outerWidth();
          } else {
            // get last showing index position
            var lastShowingIndex = slider.children.length - slider.settings.minSlides;
            position = slider.children.eq(lastShowingIndex).position();
          }
          // horizontal carousel, going previous while on first slide (infiniteLoop mode)
        } else if (slider.carousel && slider.active.last && direction == 'prev') {
          // get the last child position
          var eq = slider.settings.moveSlides == 1 ? slider.settings.maxSlides - getMoveBy() : (getPagerQty() - 1) * getMoveBy() - (slider.children.length - slider.settings.maxSlides);
          var lastChild = el.children('.bx-clone').eq(eq);
          position = lastChild.position();
          // if infinite loop and "Next" is clicked on the last slide
        } else if (direction == 'next' && slider.active.index == 0) {
          // get the last clone position
          position = el.find('> .bx-clone').eq(slider.settings.maxSlides).position();
          slider.active.last = false;
          // normal non-zero requests
        } else if (slideIndex >= 0) {
          var requestEl = slideIndex * getMoveBy();
          position = slider.children.eq(requestEl).position();
        }

        /* If the position doesn't exist
         * (e.g. if you destroy the slider on a next click),
         * it doesn't throw an error.
         */
        if ("undefined" !== typeof position) {
          var value = slider.settings.mode == 'horizontal' ? -(position.left - moveBy) : -position.top;
          // plugin values to be animated
          _setPositionProperty(value, 'slide', slider.settings.speed);
        }
      }
    };

    /**
     * Transitions to the next slide in the show
     */
    el.goToNextSlide = function () {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.last) return;
      var pagerIndex = parseInt(slider.active.index) + 1;
      el.goToSlide(pagerIndex, 'next');
    };

    /**
     * Transitions to the prev slide in the show
     */
    el.goToPrevSlide = function () {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.index == 0) return;
      var pagerIndex = parseInt(slider.active.index) - 1;
      el.goToSlide(pagerIndex, 'prev');
    };

    /**
     * Starts the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.startAuto = function (preventControlUpdate) {
      // if an interval already exists, disregard call
      if (slider.interval) return;
      // create an interval
      slider.interval = setInterval(function () {
        slider.settings.autoDirection == 'next' ? el.goToNextSlide() : el.goToPrevSlide();
      }, slider.settings.pause);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate != true) updateAutoControls('stop');
    };

    /**
     * Stops the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.stopAuto = function (preventControlUpdate) {
      // if no interval exists, disregard call
      if (!slider.interval) return;
      // clear the interval
      clearInterval(slider.interval);
      slider.interval = null;
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate != true) updateAutoControls('start');
    };

    /**
     * Returns current slide index (zero-based)
     */
    el.getCurrentSlide = function () {
      return slider.active.index;
    };

    /**
     * Returns current slide element
     */
    el.getCurrentSlideElement = function () {
      return slider.children.eq(slider.active.index);
    };

    /**
     * Returns number of slides in show
     */
    el.getSlideCount = function () {
      return slider.children.length;
    };

    /**
     * Update all dynamic slider elements
     */
    el.redrawSlider = function () {
      // resize all children in ratio to new screen size
      slider.children.add(el.find('.bx-clone')).width(getSlideWidth());
      // adjust the height
      slider.viewport.css('height', getViewportHeight());
      // update the slide position
      if (!slider.settings.ticker) setSlidePosition();
      // if active.last was true before the screen resize, we want
      // to keep it last no matter what screen size we end on
      if (slider.active.last) slider.active.index = getPagerQty() - 1;
      // if the active index (page) no longer exists due to the resize, simply set the index as last
      if (slider.active.index >= getPagerQty()) slider.active.last = true;
      // if a pager is being displayed and a custom pager is not being used, update it
      if (slider.settings.pager && !slider.settings.pagerCustom) {
        populatePager();
        updatePagerActive(slider.active.index);
      }
    };

    /**
     * Destroy the current instance of the slider (revert everything back to original state)
     */
    el.destroySlider = function () {
      // don't do anything if slider has already been destroyed
      if (!slider.initialized) return;
      slider.initialized = false;
      $('.bx-clone', this).remove();
      slider.children.each(function () {
        $(this).data("origStyle") != undefined ? $(this).attr("style", $(this).data("origStyle")) : $(this).removeAttr('style');
      });
      $(this).data("origStyle") != undefined ? this.attr("style", $(this).data("origStyle")) : $(this).removeAttr('style');
      $(this).unwrap().unwrap();
      if (slider.controls.el) slider.controls.el.remove();
      if (slider.controls.next) slider.controls.next.remove();
      if (slider.controls.prev) slider.controls.prev.remove();
      if (slider.pagerEl && slider.settings.controls) slider.pagerEl.remove();
      $('.bx-caption', this).remove();
      if (slider.controls.autoEl) slider.controls.autoEl.remove();
      clearInterval(slider.interval);
      if (slider.settings.responsive) $(window).unbind('resize', resizeWindow);
    };

    /**
     * Reload the slider (revert all DOM changes, and re-initialize)
     */
    el.reloadSlider = function (settings) {
      if (settings != undefined) options = settings;
      el.destroySlider();
      init();
    };
    init();

    // returns the current jQuery object
    return this;
  };
})(jQuery);

/*!
 * Float Labels
 * @version: 3.3.9
 * @author: Paul Ryley (http://geminilabs.io)
 * @url: https://pryley.github.io/float-labels.js
 * @license: MIT
 */
!function (t, r, e) {
  "use strict";

  var n = function n(t, e) {
    this.t = this.e(t) ? r.querySelectorAll(t) : [t], this.n = [], this.i = e, this.r = [], this.o(), this.destroy = function () {
      this.u(function (t) {
        t.removeEventListener("reset", this.events.reset), this.s(t);
      }, function (t) {
        this.a(t);
      });
    }, this.rebuild = function () {
      this.u(null, function (t) {
        this.l(t, !0);
      });
    };
  };
  n.prototype = {
    c: {
      customEvent: null,
      customLabel: null,
      customPlaceholder: null,
      exclude: ".no-label",
      inputRegex: /email|number|password|search|tel|text|url/,
      prefix: "fl-",
      prioritize: "label",
      requiredClass: "required",
      style: 0,
      transform: "input,select,textarea"
    },
    o: function o() {
      var i = this;
      i.f(), i.u(function (t, e) {
        var n = i.n[e].style;
        t.addEventListener("reset", i.events.reset), t.classList.add(i.h("form")), n && t.classList.add(i.h("style-" + n));
      }, function (t) {
        i.l(t);
      });
    },
    f: function f() {
      var t = this;
      t.events = {
        blur: t.d.bind(t),
        change: t.v.bind(t),
        focus: t.p.bind(t),
        input: t.v.bind(t),
        reset: t._.bind(t)
      };
    },
    b: function b(t) {
      return t ? "add" : "remove";
    },
    m: function m(t) {
      var e = this,
        n = e.y(t);
      n && (t.classList.add(e.h(t.tagName.toLowerCase())), e.L(n, t), e.g(n, t), e.w(n, t), e.x(t, "add"), "function" == typeof e.n[e.S].customEvent && e.n[e.S].customEvent.call(e, t));
    },
    T: function T(t, e) {
      var n = "string" == typeof t ? r.createElement(t) : t;
      for (var i in e = e || {}) e.hasOwnProperty(i) && n.setAttribute(i, e[i]);
      return n;
    },
    C: function C() {
      var t = [].slice.call(arguments),
        n = t[0],
        i = t.slice(1);
      return Object.keys(i).forEach(function (t) {
        for (var e in i[t]) i[t].hasOwnProperty(e) && (n[e] = i[t][e]);
      }), n;
    },
    l: function l(t, e) {
      var n = this;
      if (n.P(t)) {
        if (n.j(t)) {
          if (!0 !== e) return;
          n.a(t);
        }
        n.m(t);
      }
    },
    y: function y(t) {
      var e = 'label[for="' + t.getAttribute("id") + '"]',
        n = this.t[this.S].querySelectorAll(e);
      return 1 < n.length && (n = t.parentNode.querySelectorAll(e)), 1 === n.length && n[0];
    },
    q: function q(t, e) {
      var n = t.textContent.replace("*", "").trim(),
        i = e.getAttribute("placeholder");
      return (!n || n && i && "placeholder" === this.n[this.S].prioritize) && (n = i), n;
    },
    x: function x(e, n) {
      var i = this.events;
      ["blur", "input", "focus"].forEach(function (t) {
        "input" !== t || "file" !== e.type && "SELECT" !== e.nodeName || (t = "change"), e[n + "EventListener"](t, i[t]);
      });
    },
    j: function j(t) {
      return t.parentNode.classList.contains(this.h("wrap"));
    },
    e: function e(t) {
      return "[object String]" === Object.prototype.toString.call(t);
    },
    P: function P(t) {
      var e = "INPUT" === t.tagName && !this.n[this.S].inputRegex.test(t.getAttribute("type")),
        n = "SELECT" === t.tagName && null !== t.getAttribute("multiple");
      return t.getAttribute("id") && !e && !n;
    },
    u: function u(t, e) {
      for (var n = this, i = 0; i < n.t.length; ++i) {
        if (void 0 === n.r[i]) {
          var r = n.C({}, n.c, n.i, n.t[i].getAttribute("data-options")),
            o = ":not(" + r.exclude.split(/[\s,]+/).join("):not(") + ")";
          n.r[i] = r.transform.replace(/,/g, o + ",") + o, n.n[i] = r;
        }
        var u = n.t[i].querySelectorAll(n.r[i]);
        n.S = i, "function" == typeof t && t.call(n, n.t[i], i);
        for (var s = 0; s < u.length; ++s) "function" == typeof e && e.call(n, u[s], i);
      }
    },
    d: function d(t) {
      t.target.parentNode.classList.remove(this.h("has-focus"));
    },
    v: function v(t) {
      t.target.parentNode.classList[this.b(t.target.value.length)](this.h("is-active"));
    },
    p: function p(t) {
      t.target.parentNode.classList.add(this.h("has-focus"));
    },
    _: function _() {
      setTimeout(this.F.bind(this));
    },
    h: function h(t) {
      return this.n[this.S].prefix + t;
    },
    s: function s(t) {
      var e = this.n[this.S].prefix,
        n = t.className.split(" ").filter(function (t) {
          return 0 !== t.lastIndexOf(e, 0);
        });
      t.className = n.join(" ").trim();
    },
    a: function a(t) {
      var e = t.parentNode;
      if (this.j(t)) {
        for (var n = r.createDocumentFragment(); e.firstElementChild;) {
          var i = e.firstElementChild;
          this.s(i), n.appendChild(i);
        }
        e.parentNode.replaceChild(n, e), this.O(t), this.x(t, "remove");
      }
    },
    F: function F() {
      for (var t = this, e = t.t[t.S].querySelectorAll(t.r[t.S]), n = 0; n < e.length; ++n) e[n].parentNode.classList[t.b("SELECT" === e[n].tagName && "" !== e[n].value)](t.h("is-active"));
    },
    O: function O(t) {
      var e = "data-placeholder",
        n = t.getAttribute(e);
      null !== n && (t.removeAttribute(e), t.setAttribute("placeholder", n));
    },
    L: function L(t, e) {
      var n = this;
      t.classList.add(n.h("label")), t.textContent = n.q(t, e), "function" == typeof n.n[n.S].customLabel && (t.textContent = n.n[n.S].customLabel.call(n, t, e));
    },
    g: function g(t, e) {
      var n = this,
        i = e.getAttribute("placeholder");
      "label" !== n.n[n.S].prioritize && i || (i && e.setAttribute("data-placeholder", i), i = n.q(t, e)), "function" == typeof n.n[n.S].customPlaceholder && (i = n.n[n.S].customPlaceholder.call(n, i, e, t)), "SELECT" === e.tagName ? n.R(e, i) : e.setAttribute("placeholder", i);
    },
    R: function R(t, e) {
      var n = t.firstElementChild;
      n.hasAttribute("value") && n.value ? (t.insertBefore(new Option(e, ""), n), !1 === t.options[t.selectedIndex].defaultSelected && (t.selectedIndex = 0)) : n.setAttribute("value", ""), "" === n.textContent && (n.textContent = e);
    },
    w: function w(t, e) {
      var n = this,
        i = n.T("div", {
          "class": n.h("wrap") + " " + n.h("wrap-" + e.tagName.toLowerCase())
        });
      void 0 !== e.value && e.value.length && i.classList.add(n.h("is-active")), (null !== e.getAttribute("required") || e.classList.contains(n.n[n.S].requiredClass)) && i.classList.add(n.h("is-required")), e.parentNode.insertBefore(i, e), i.appendChild(t), i.appendChild(e);
    }
  }, "function" == typeof define && define.amd ? define([], function () {
    return n;
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = n : t.FloatLabels = n;
}(window, document);
jQuery(document).ready(function () {
  ShowAndHideFaqs();
  applyPageShowHide();
  initialize();
  jQuery(".mega-menu-link").removeAttr("aria-expanded");
  var gaCode = getCookie("_ga");
  jQuery(".elementor-search-form__toggle").click(function (event) {
    event.preventDefault();
    if (event.target.className == "fas fa-search") {
      jQuery(".elementor-search-form__toggle").html('<i class="eicon-close" aria-hidden="true"></i>');
      jQuery(".dialog-close-button").html('<input id="inptSearchBtn" value="Go" title="search" type="submit">');
      //jQuery(".dialog-close-button").html('<button id="inptSearchBtn" title="search" type="submit"></button>');
    } else {
      jQuery(".dialog-close-button").html('<i class="eicon-close" aria-hidden="true"></i>');
      jQuery(".elementor-search-form__toggle").html('<i aria-hidden="true" class="fas fa-search"></i>');
    }
  });

  // This code is used for program page in addmission section.
  jQuery(".admission-section .cf-about-brand-elementor-widget").hide();
  jQuery(".admission-section .show-link").on("click", function (event) {
    jQuery(".admission-section .cf-about-brand-elementor-widget").toggle();
  });

  // floating labels not shown if not option choose
  if (jQuery(".cf-programs-list .gfield_select").find(":selected").val() !== "") {
    jQuery(".cf-programs-list .ginput_container_select .gfield_label").show();
    jQuery(".hear .ginput_container_select .gfield_label").hide();
  } else jQuery(".ginput_container_select .gfield_label").hide();
  jQuery(".gfield_select").attr("value", "");
  jQuery(".cf-programs-list .ginput_container_select .gfield_label").hide();
  jQuery(".gfield_select").change(function () {
    var $currEl = jQuery(this);
    //jQuery('.gfield_label', $currEl.parent()).css({opacity: 1});
    var selectOptionValue = jQuery("option:selected", this);
    jQuery(".gfield_select").attr("value", selectOptionValue[0].value);
    if (selectOptionValue[0].value) jQuery(".gfield_label", $currEl.parent()).show();else jQuery(".gfield_label", $currEl.parent()).hide();
  });
  jQuery(".popup-apply-form-LP .gfield input").removeAttr("disabled");
  jQuery("a.skip-main").on("click", function (event) {
    event.stopPropagation();
  });

  //set form button select to current program code
  jQuery(document).on("click", ".apply-now-popup, .request-info-popup-LP", function (event) {
    if (jQuery(this).is("[data-program-code]")) {
      var code = jQuery(this).attr("data-program-code");
      if (code == "undefined" || code == "" || code == "{internal_program_code}") {
        return false;
      } else {
        popupformSelectOption(code);
      }
      if (code !== "" && code != undefined) {
        jQuery(".cf-programs-list .ginput_container_select .gfield_label").addClass("showLabel");
      }
    }
  });
  jQuery(".dialog-lightbox-close-button").on("click", function (event) {
    jQuery(".elementor-search-form").submit();
  });
  jQuery(".cf-programs-groups-tab-menu .elementor-tab-title").on("click", function (event) {
    // this code used to remove initial class on click.
    jQuery(".cf-programs-groups-tab-menu .elementor-tab-title.initial").removeClass("initial");
    if (jQuery("body").hasClass("mobile")) {
      jQuery("html, body").animate({
        scrollTop: jQuery("#degree-showcase-main").offset().top
      }, "800");
    }
  });
  jQuery(".linkbox-left:empty").closest("div.linkbox").hide();
  jQuery(".elementor-widget-cf-program-field h3:empty").closest("div.elementor-widget-cf-program-field:not(.tuition-toggle-link)").hide();
  jQuery(".cf-program-details-btn-close .elementor-button").on("click", function (event) {
    if (jQuery("body").hasClass("mobile")) {
      jQuery("html, body").animate({
        scrollTop: jQuery(".degree-showcase-main").offset().top
      }, "800");
    }
  });

  // Check (onLoad) if the cookie is there and set the class if it is
  if (jQuery.cookie("highcontrast") == "yes") {
    jQuery("body").addClass("highcontrast");
  }
  jQuery("a.high-contrast").click(function () {
    if (jQuery.cookie("highcontrast") == "undefined" || jQuery.cookie("highcontrast") == "no") {
      jQuery.cookie("highcontrast", "yes", {
        expires: 7,
        path: "/"
      });
      jQuery("body").addClass("highcontrast");
    } else {
      jQuery.cookie("highcontrast", "yes", {
        expires: 7,
        path: "/"
      });
      jQuery("body").addClass("highcontrast");
    }
  });
  jQuery("a.normal-contrast").click(function () {
    jQuery("body").removeClass("highcontrast");
    if (jQuery.cookie("highcontrast") == "yes") {
      jQuery.cookie("highcontrast", null, {
        path: "/"
      });
    }
  });

  //Base Script for application instructins
  jQuery(".CLASS").hide();
  jQuery(".CLASS").hide();
  var apply2Url = getUrlParameter("d");
  if (apply2Url != null && apply2Url != "") {
    jQuery("#apply2url").attr("href", "/application-instructions/?d=" + apply2Url);
    if (apply2Url == "CRMCODE" || apply2Url == "CRMCODE" || apply2Url == "CRMCODE" || apply2Url == "CRMCODE" || apply2Url == "CRMCODE") {
      jQuery(".CLASS").hide();
      jQuery(".CLASS").show();
    } else {
      jQuery(".CLASS").show();
    }
  } else {
    jQuery(".CLASS").show();
  }

  /*hide one apply now button in full with form*/
  if (jQuery("body").hasClass("archive")) {
    jQuery(".degree-btn").hide();
  }
});

// set id for sap module.
window.addEventListener("load", function () {
  jQuery(".sap-module").attr("id", "degree-showcase-main");
});

//WCAG
jQuery(document).on("click keypress", ".button-tab", function (e) {
  //add role and aria-label to the X for click or keypress
  if (event.type === "click") {
    //for the modal
    jQuery(".dialog-close-button").attr({
      role: "button",
      "aria-label": "Close dialog"
    });
    jQuery(".dialog-close-button").attr({
      tabIndex: 0
    });
    jQuery(".dialog-widget-content").attr({
      role: "dialog",
      "aria-labelledby": "form-title"
    });
    jQuery(".dialog-message .form-title").attr({
      tabIndex: -1
    });
    jQuery(".dialog-message .form-title").focus();
  } else if (event.type === "keypress") {
    var code = event.charCode || event.keyCode;
    if (code === 32 || code === 13) {
      //for the modal
      jQuery(".dialog-close-button").attr({
        role: "button",
        "aria-label": "Close dialog"
      });
      jQuery(".dialog-close-button").attr({
        tabIndex: 0
      });
      jQuery(".dialog-widget-content").attr({
        role: "dialog",
        "aria-labelledby": "form-title"
      });
      jQuery(".dialog-message .form-title").attr({
        tabIndex: -1
      });
      jQuery(".dialog-message .form-title").focus();
    }
  }
});

//WCAG
jQuery(document).ready(function () {
  jQuery("a[href^='#mainContent']").attr({
    "aria-hidden": "true"
  });
  jQuery("a[href^='#mainContent']").append('<span style="text-indent: -99999px; display:block;">Skip to main content</span>');
});

//WCAG
jQuery(document).on("gform_post_render", function (e, form_id) {
  if (jQuery("div.validation_error").length > 0) {
    jQuery(".validation_message").each(function () {
      var message_id = jQuery(this).attr("id");
      var previous_div = jQuery(this).prev().children();
      jQuery(previous_div).attr("aria-describedby", message_id);
    });
  }
  //this is we can combine forms - hiding this dropdown on landing pages
  if (jQuery("body").hasClass("landing-page")) {
    //jQuery('li.hear').hide();
    jQuery("li.hear").remove();
  }
  jQuery(".gfield_select").attr("value", "");
  jQuery(".ginput_container_select .gfield_label").hide();
  jQuery(".gfield_select").change(function () {
    var $currEl = jQuery(this);
    jQuery(".gfield_label", $currEl.parent()).removeClass("showLabel");
    var selectOptionValue = jQuery("option:selected", this);
    jQuery(".gfield_select").attr("value", selectOptionValue[0].value);
    if (selectOptionValue[0].value) jQuery(".gfield_label", $currEl.parent()).show();else jQuery(".gfield_label", $currEl.parent()).hide();
  });
  var isDisabled = jQuery(".popup-apply-form-LP .gfield input").is(":disabled");
  if (isDisabled) jQuery(".popup-apply-form-LP .gfield input").removeAttr("disabled");else jQuery(".popup-apply-form-LP .gfield input").removeAttr("disabled");
});

//WCAG
jQuery(document).on("change", ".select-for-apply-page select", function (e) {
  var selectedOptionText = jQuery("option:selected", this).text();
  jQuery(".apply-lead-form input").each(function () {
    var placeholder = jQuery(this).attr("placeholder");
    jQuery(this).attr({
      "aria-label": selectedOptionText + " Track Application - Student " + placeholder
    });
  });
  jQuery(".apply-lead-form select").each(function () {
    var placeholder = jQuery(".apply-lead-form select option:selected").text();
    jQuery(this).attr({
      "aria-label": selectedOptionText + " Track Application - Student " + placeholder
    });
  });
});

// WCAG - add all the elements inside modal which you want to make focusable (keeps tab inside of modal)
jQuery(document).on("click keypress", ".elementor-button, .request-info-popup", function (e) {
  var modal = document.querySelector(".elementor-popup-modal"); // select the modal by it's id
  var focusableElements = jQuery(modal).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  var firstFocusableElement = focusableElements.first(); // get first element to be focused inside modal
  var lastFocusableElement = focusableElements.last(); // get last element to be focused inside modal

  /*set focus on first input*/
  //firstFocusableElement.focus();

  /*redirect last tab to first input*/
  lastFocusableElement.on("keydown", function (e) {
    if (e.which === 9 && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });

  /*redirect first shift+tab to last input*/
  firstFocusableElement.on("keydown", function (e) {
    if (e.which === 9 && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    }
  });

  //this is we can combine forms - hiding this dropdown on landing pages
  if (jQuery("body").hasClass("landing-page")) {
    jQuery("li.hear").hide();
  }
});
function getCookie(c_name) {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
}

//wcag edits
jQuery(document).on("click", ".elementor-button", function (e) {
  jQuery(".dialog-close-button").attr({
    role: "button",
    "aria-label": "Close dialog"
  });
});
function ShowAndHideFaqs() {
  jQuery("#showHideFaqs").click(function () {
    if (jQuery("#showHideFaqs").text() == "Close All [-]") {
      jQuery(".elementor-widget-container .elementor-tab-title").removeClass("elementor-active");
      jQuery(".elementor-widget-container .elementor-tab-content").hide();
      jQuery("#showHideFaqs").text("Expand All [+]");
    } else {
      jQuery(".elementor-widget-container .elementor-tab-title").addClass("elementor-active");
      jQuery(".elementor-widget-container .elementor-tab-content").show();
      jQuery("#showHideFaqs").text("Close All [-]");
    }
  });
}

//landing page collapse first program tab
jQuery(window).on("load", function () {
  if (jQuery(".cf-programs-list .gfield_select").find(":selected").val() !== "") {
    jQuery(".cf-programs-list .ginput_container_select .gfield_label").show();
    jQuery(".hear .ginput_container_select .gfield_label").hide();
  } else jQuery(".ginput_container_select .gfield_label").hide();
  jQuery(".popup-apply-form-LP .gfield input").removeAttr("disabled");
});
function initialize() {
  jQuery(".cf-programs-groups-tab-menu .elementor-tab-title").removeClass("elementor-active");
  jQuery(".cf-programs-groups-tab-menu .elementor-tab-title").attr("aria-expanded", "false");
  jQuery(".cf-programs-groups-tab-menu .elementor-tab-title").first().addClass("initial");
  jQuery(".cf-programs-groups-tab-menu .elementor-tab-title").first().attr("aria-expanded", "true");
  jQuery(".cf-programs-groups-tab-menu .elementor-tab-title.initial").addClass("elementor-active");
  jQuery(".cf-programs-group-elementor-widget ul").each(function () {
    jQuery(this).children("li").removeClass("elementor-active");
    jQuery(this).children("li").attr("aria-expanded", "false");
  });
  jQuery(".cf-programs-group-elementor-widget ul:first").each(function () {
    jQuery(this).children("li:first").addClass("initial");
    jQuery(this).children("li:first").attr("aria-expanded", "true");
  });
  jQuery(".cf-programs-group-elementor-widget .initial").addClass("elementor-active");
}

//landing page collapse first program tab
jQuery(window).on("load", function () {
  if (jQuery("body").hasClass("mobile")) {
    jQuery(".cf-programs-groups-tab-menu .elementor-tab-title").removeClass("elementor-active");
    jQuery(".cf-programs-group-elementor-widget .elementor-tab-title").removeClass("elementor-active");
  }
  jQuery(".cf-programs-groups-tab-menu .elementor-tab-title").eq(0).addClass("elementor-active");
});

//validation after submit for input
jQuery(document).on("focusout", ".ap-lead-form input, .apply-lead-form input", function (e) {
  if (jQuery(this).val()) {
    jQuery(this).parent().parent().removeClass("gfield_error");
    jQuery(this).parent().next("div").hide("validation_message");
  }
});

//validation after submit for select
jQuery(document).on("change", ".ap-lead-form select, .apply-lead-form select", function (e) {
  jQuery(this).parent().parent().removeClass("gfield_error");
  jQuery(this).parent().next("div").hide("validation_message");
});

//for program poup so that select option matches program clicked on
var modalInterval;
function popupformSelectOption(programsCode) {
  //jQuery('.cf-programs-list select').val(code);
  var currentProgramCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var $modal = jQuery("body").find(".elementor-popup-modal");
  var $popupForm = $modal.find(".ap-lead-form");
  var $programsList = $popupForm.find(".cf-programs-list select");
  var time = 50; // Check to see if the modal's content is loaded.

  //console.log(currentProgramCode);

  if ($popupForm.length) {
    if ($programsList.length) {
      time = 0;
    }
  } // Wait until the modal's content is full loaded.

  clearInterval(modalInterval);
  modalInterval = setInterval(function () {
    if (time !== 0) {
      $modal = jQuery("body").find(".elementor-popup-modal");
      $popupForm = $modal.find(".ap-lead-form");
      $programsList = $popupForm.find(".cf-programs-list select");
    }
    if ($popupForm.length) {
      if ($programsList.length) {
        clearInterval(modalInterval); // Go through all the Program Options and check to see if the program must be removed from the list, or not.

        if (programsCode) {
          $programsList.find("option[value=" + programsCode + "]").attr("selected", "selected");
        }
      }
    }
  }, time);
}

/*----- Apply Page Text hide -------*/
function applyPageShowHide() {
  jQuery(".apply-page-form-footer").hide();
  jQuery(".select-for-apply-page").change(function () {
    if (jQuery("option:selected", this).text() == "Program of Interest*") {
      jQuery(".apply-page-form-footer").hide();
    } else {
      jQuery(".apply-page-form-footer").show();
    }
    var selectedOptionText = jQuery("option:selected", this).text();
    jQuery(".admission_requirements span").html(selectedOptionText + " online ");
  }).trigger("change");
}
jQuery(document).on("gform_page_loaded", function (event, form_id, current_page) {
  var selectedOptionText = jQuery(".select-for-apply-page option:selected").text();
  jQuery(".admission_requirements span").html(selectedOptionText + " online");
});
function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
jQuery(document).ready(function () {
  //Script for Explore Page Sidebar Fix
  jQuery(document).scroll(function (event) {
    if (jQuery(window).width() > 800) {
      var top = jQuery(".header").height();
      var bottom = jQuery(".footer").height() + 110;
      var scrolls = jQuery(document).scrollTop();
      if (scrolls > jQuery(".explore-content").height() - 500) {
        jQuery("body.explore").find(".explore-middle").find(".anchor-links").css({
          bottom: bottom,
          top: "initial",
          height: "auto"
        });
      } else if (scrolls < top + 150) {
        jQuery("body.explore").find(".explore-middle").find(".anchor-links").css({
          top: "initial",
          bottom: "initial",
          height: "auto"
        });
      } else {
        jQuery("body.explore").find(".explore-middle").find(".anchor-links").css({
          top: top,
          bottom: "initial",
          height: "auto"
        });
      }
    }
  });

  //Add arai label attribute for chart on explore page.
  for (var i = 0; i < jQuery('div[role="progressbar"]').length; i++) {
    jQuery('div[role="progressbar"]').eq(i).attr("aria-label", jQuery('div[role="progressbar"] .elementor-progress-text').eq(i).text());
  }
});
//Remove arai Selected attribute for accessbility on SAP2 page.
jQuery(".cf-programs-groups-tab-menu elementor-toggle .cf-title").removeAttr("aria-selected");
(function ($) {
  jQuery(document).ready(function ($) {
    jQuery.noConflict();
    $('.grid-nav').unbind('click').bind('click', function (event) {
      if ($(this).siblings('div').length) {}
    });
  });
})(jQuery);
// -------------------- DEFINE VARIABLES --------------------

var animationSpeed = 250;
var animationSpeedSlow = 450;
var availableViewSpace;
var currentStickyTop;
var enableScrollFunctions = 0;
var hashTargetTop;
var headerHeightScrollDown;
var headerHeightAtTop;
var headerHeightScrollUpSome;
var headerHeightScrollTop;
var myMaxHeight = 0;
var myMinHeight;
var offsetScrollPosition = 0;
var pageLoadFlag = 1;
var prevScrollPosition = 0;
var scrollOffset = 0;
var scrollPosition = 0;
var scrollPositionOffset = 0;
var scrollThreshold = 5;
var scrollTimeout;
var stickyHeight;
var targetHREF;
var theSectionTop;
var theSectionHeight;
var theSectionBottom;
var theSubnavHREF;
var totalHeaderScrollDownHideHeight = 0;
var totalHeaderScrollDownHideHeightTopOnly = 0;

// -------------------- END DEFINE VARIABLES --------------------

// -------------------- ON PAGE LOAD EVENT --------------------
(function ($) {
  jQuery(document).ready(function ($) {
    jQuery.noConflict();
    moveThisFunctions();
    window.onload = function () {
      initializePage();
    };

    // set body class to desktop by default, then run check
    $("body").addClass("desktop");
    detectDesktopOrMobile();
    // move elements that switch positions between desktop and mobile
    moveThis();
    // initialize position, heights, related values
    initializePage();
    // if page loads with hash in URL, run handler to put page at correct location
    if (window.location.hash) {
      goToHash($(location).attr('hash'));
    }
    // wait 100 ms for all script checks to run, then reset page load flag and enable the scroll functions. This prevents any scroll-based functions from accidentally triggering on page load
    setTimeout(function () {
      enableScrollFunctions = 1;
      pageLoadFlag = 0;
      headerHeightHandler();
    }, 200);
  });

  // -------------------- END ON PAGE LOAD --------------------

  // -------------------- EVENTS --------------------

  // EVENT : scrolling
  $(window).scroll(function () {
    if (scrollTimeout) {
      // clear the timeout, if one is pending
      clearTimeout(scrollTimeout);
      scrollTimeout = null;
    }
    scrollTimeout = setTimeout(scrollHandler, 10);
  });

  // EVENT : resizing window
  $(window).resize(function () {
    // determine responsive view
    detectDesktopOrMobile();
    headerHeightHandler();
    tableScrolling();
    moveThisFunctions();
  });

  // EVENT: clicking an anchor link
  $(document).on('click', 'a[href^="#"]', function (event) {
    // optional: prevent # id from appearing in URL bar
    event.preventDefault();

    // get the hash target
    targetHREF = $.attr(this, 'href');
    // optional: change URL bar, but not if the href is "#top" or "#"
    if (targetHREF != "#top" && targetHREF != "#") {
      history.pushState(null, null, targetHREF);
    }
    // when the hash is #, it could mean different things. This cycles through the options and triggers a corresponding function
    if (targetHREF == "#") {
      if ($(this).hasClass("search-open") || $(this).hasClass("search-close")) {
        searchShowHide(this);
      }

      // basic show-hides
      if ($(this).hasClass("show-link")) {
        event.stopPropagation();
        if ($(this).closest(".show-link-parent").next(".show-content").css("display") == "none") {
          $(this).closest(".show-link-parent").next(".show-content").slideDown('fast');
          $(this).addClass("active");
          $(this).children().each(function () {
            showHideTogglesOpened($(this));
          });
          tableScrolling();
        } else {
          $(this).closest(".show-link-parent").next(".show-content").slideUp('fast');
          $(this).removeClass("active");
          $(this).children().each(function () {
            showHideTogglesClosed($(this));
          });
        }
      }

      // expand/contract fixed-height-fade-content elements
      if ($(this).parent().hasClass("fixed-height-fade-content-toggle")) {
        fixedHeightContent(this);
      }
    } else {
      // run hash animation handler
      goToHash(targetHREF);
    }
  });

  // EVENT: when the URL hash changes, reload page completely to reset various parameters
  $(window).on("hashchange", function (event) {
    location.reload();
  });

  // -------------------- END EVENTS --------------------

  // -------------------- CALLABLE FUNCTIONS --------------------

  // FUNCTION : handle back-to-top link in fixed footer
  function backToTop(direction) {
    if ($("body").hasClass("desktop") && !$(".back-to-top").hasClass("mobile-only")) {
      // scrolling down
      if (direction == "down") {
        $(".back-to-top").hide();
      }
      // scrolled up
      else {
        if (scrollPosition < headerHeightAtTop) {
          // hide back-to-top
          $(".back-to-top").hide();
        } else {
          // show back-to-top
          $(".back-to-top").show();
        }
      }
    } else if ($("body").hasClass("mobile") && !$(".back-to-top").hasClass("desktop-only")) {
      // scrolling down
      if (direction == "down") {
        $(".back-to-top").hide();
      }
      // scrolled up
      else {
        if (scrollPosition < headerHeightAtTop) {
          // hide back-to-top
          $(".back-to-top").hide();
        } else {
          // show back-to-top
          $(".back-to-top").show();
        }
      }
    }
  }

  // FUNCTION : detect desktop or mobile view based on CSS
  function detectDesktopOrMobile() {
    // detect if desktop
    if ($("body").css("max-width") != "9999px") {
      // detect if transitioning to desktop from mobile
      if ($("body.mobile").length) {
        $('body').removeClass('mobile');
        $('body').addClass('desktop');
        moveThis();
        // reset show/hides, heights, positioning
        initializePage();
      }
    }
    // detect if mobile
    else {
      // detect if transitioning to mobile from desktop
      if ($("body.desktop").length) {
        $('body').removeClass('desktop');
        $('body').addClass('mobile');
        moveThis();
        // reset show/hides, heights, positioning
        initializePage();
      }
    }
  }

  // FUNCTION : fixed-height elements with fade
  function fixedHeightContent(target) {
    myParent = $(target).closest(".fixed-height-fade-content");
    if ($(myParent).hasClass("closed")) {
      myMinHeight = $(myParent).innerHeight();
      $(myParent).removeClass("closed");
      if (myMaxHeight == 0) {
        myMaxHeight = $(myParent).innerHeight() + $(target).height();
      }
      $(myParent).css({
        "max-height": myMinHeight
      });
      $(myParent).animate({
        "max-height": myMaxHeight
      }, animationSpeed);
      $(target).addClass("open");
    } else {
      myMaxHeight = $(myParent).innerHeight();
      $(myParent).addClass("closed");
      $(myParent).animate({
        "max-height": myMinHeight
      }, animationSpeed);
      $(target).removeClass("open");
    }
  }

  // FUNCTION: handle navigating to a hash target
  function goToHash(hashTarget) {
    // if the hashtag is not just # <-- not necessary anymore, but retaining just in case
    if (hashTarget != "#") {
      // if the target is the top
      if (hashTarget == "#top") {
        $('html, body').animate({
          scrollTop: 0
        }, animationSpeed, function () {
          subnavActive();
        });
      }
      // if target is not top
      else {
        // get target top value
        hashTargetTop = $(hashTarget).offset().top;
        // initialize scroll offset value for the hash target. This is what adjusts the scroll amount to account for fixed header size.
        scrollOffset = 0;
        // only do this if header is fixed and offset is required
        if ($(".header").hasClass("fixed")) {
          // initialize scroll offset value for the hash target. This is what adjusts the scroll amount to account for fixed header size.
          scrollOffset = 0;
          // calculate the scroll offset:
          // go through each visible, top-sticky sibling of the fixed header and look for the target. If it's not there, add the height of this element to the scroll offset total.
          $(".header.fixed").siblings().each(function () {
            if ($(this).find(hashTarget).length <= 0 && $(this).hasClass("top-sticky") && $(this).is(":visible")) {
              scrollOffset = scrollOffset + $(this).outerHeight();
            }
          });

          // if page is just now being loaded, i.e. clicked link on another page to get here
          if (pageLoadFlag == 1) {
            //since page is already at top, header is full height. The new target scroll position should equal the full height of the header plus the total height of the visible top-sticky header siblings.
            hashTargetTop = hashTargetTop - headerHeightAtTop - scrollOffset;
            // since page is loading, no scroll animation is desired - just jump to the target point
            $('html, body').animate({
              scrollTop: hashTargetTop
              //}, 0);
            }, 10, function () {
              subnavActive();
            }); // if needing to scroll down because page is reset
          }

          // if page is already loaded, i.e. link clicked on same page
          else {
            // if navigating to hash target involves scrolling down
            if (hashTargetTop > scrollPosition) {
              // offset (decrease) target position by the predicted height of the header after scrolling down and the total height of the visible top-sticky header siblings.
              hashTargetTop = hashTargetTop - headerHeightScrollDown - scrollOffset;
            }
            // if navigating to hash target involves scrolling up
            else if (hashTargetTop < scrollPosition) {
              // offset (decrease) target position by the predicted height of the header after scrolling up some and the total height of the visible top-sticky header siblings.
              hashTargetTop = hashTargetTop - headerHeightScrollUpSome - scrollOffset;
            }
            // if already at hash target position, just exit
            else if (hashTargetTop == scrollPosition) {
              return;
            }
            // scroll to offset target point, slightly slower than animation speed
            $('html, body').animate({
              scrollTop: hashTargetTop
            }, animationSpeed + 100, function () {
              subnavActive();
            });
          }
        }
      }
    }
  }

  // FUNCTION : handle header/fixed/sticky element heights
  function headerHeightHandler() {
    // only do this if header is fixed
    if ($(".header").hasClass("fixed")) {
      // desktop and mobile views are handled separately
      if ($("body").hasClass("desktop")) {
        // predict height of header when scrolled down. Start with initial value of header at top
        headerHeightScrollDown = headerHeightAtTop;
        // then subtract the heights of each element that will hide on scroll down
        $(".desktop-scroll-down-hide").each(function () {
          headerHeightScrollDown = headerHeightScrollDown - $(this).outerHeight();
        });
        // predict height of header when scrolled up but not all the way to top. Start with value of header when scrolled down
        headerHeightScrollUpSome = headerHeightScrollDown;
        // then add the heights of each element that will show on scroll up
        $(".desktop-scroll-up-show").each(function () {
          headerHeightScrollUpSome = headerHeightScrollUpSome + $(this).outerHeight();
        });
        // predict height of header when scrolled to top. In this case, it should already equal the initial value of header at top because you can't scroll down to get to the top anyway.
        headerHeightScrollTop = headerHeightAtTop;
      }
      // desktop and mobile views are handled separately
      else if ($("body").hasClass("mobile")) {
        // predict height of header when scrolled down. Start with initial value of header at top
        headerHeightScrollDown = headerHeightAtTop;
        // then subtract the heights of each element that will hide on scroll down
        $(".mobile-scroll-down-hide").each(function () {
          headerHeightScrollDown = headerHeightScrollDown - $(this).outerHeight();
        });
        // predict height of header when scrolled up but not all the way to top. Start with value of header when scrolled down
        headerHeightScrollUpSome = headerHeightScrollDown;
        // then add the heights of each element that will show on scroll up
        $(".mobile-scroll-up-show").each(function () {
          headerHeightScrollUpSome = headerHeightScrollUpSome + $(this).outerHeight();
        });
        // predict height of header when scrolled to top. In this case, it should already equal the initial value of header at top because you can't scroll down to get to the top anyway.
        headerHeightScrollTop = headerHeightAtTop;
      }
    }
    $(".top-sticky:visible").each(function () {
      stickyHeight = $(this).outerHeight();
      availableViewSpace = $(window).height() - headerHeightScrollDown;
      $(".fixed").not(".header").each(function () {
        availableViewSpace = availableViewSpace - $(this).outerHeight();
      });
      currentStickyTop = $(this).offset().top;
      $(".top-sticky:visible").each(function () {
        if ($(this).offset().top < currentStickyTop) {
          availableViewSpace = availableViewSpace - $(this).outerHeight();
        }
      });
      if (stickyHeight >= availableViewSpace) {
        $(this).css({
          "position": "relative"
        });
        $(this).css({
          "top": "auto"
        });
      } else {
        $(this).css({
          "position": "sticky"
        });
      }
    });
  }

  // FUNCTION : initialize positions, heights, related values
  function initializePage() {
    headerHeightAtTop = $(".header").outerHeight();
    $("body").css({
      "padding-top": headerHeightAtTop
    });
    $("body.landing-page").css({
      "padding-top": 0
    });
    scrollPosition = $(this).scrollTop();
    prevScrollPosition = scrollPosition;
    if ($("body").hasClass("desktop")) {
      $(".desktop-scroll-down-hide").show();
      $(".mobile-scroll-down-hide").show();
    } else if ($("body").hasClass("mobile")) {
      $(".desktop-scroll-down-hide").show();
      $(".mobile-scroll-down-hide").show();
    }
    headerHeightHandler();
    setTopStickyTops(headerHeightAtTop);
    $(".content-section").each(function () {
      thisSectionsTop = $(this).offset().top;
      thisSectionsHeight = $(this).outerHeight();
      thisSectionsBottom = thisSectionsTop + thisSectionsHeight;
      $(this).find(".sectionTop").text("top: " + thisSectionsTop + ", height: " + thisSectionsHeight + ", bottom: " + thisSectionsBottom);

      //$(this).find(".sectionTop").text( "top: "+$(this).offset().top+", bottom );
    });
    setTimeout(tableScrolling, 1);

    //$(".msg").text(scrollPosition);
  }

  // FUNCTION : Move things from one area to another on mobile-desktop switch
  function moveThis() {
    // Instructions: give the item you want to move the '.moveThis' class and an ID. Give the two alternating containers the same ID with -desktop and -mobile appended.
    $('.move-this').each(function () {
      var moveTargetID = $(this).attr('id');
      // Mobile
      if ($("body").hasClass("mobile")) {
        if ($("#" + moveTargetID + "-mobile #" + moveTargetID + "").length == 0) {
          $("#" + moveTargetID + "").appendTo($("#" + moveTargetID + "-mobile"));
        }
      }
      // Desktop
      else if ($("body").hasClass("desktop")) {
        if ($("#" + moveTargetID + "-desktop #" + moveTargetID + "").length == 0) {
          $("#" + moveTargetID + "").appendTo($("#" + moveTargetID + "-desktop"));
        }
      }
    });
  }

  // FUNCTION : handle what happens when you scroll
  function scrollHandler() {
    // get current scroll position
    scrollPosition = $(this).scrollTop();
    // make sure scroll amount is significant, else cancel
    if (Math.abs(prevScrollPosition - scrollPosition) <= scrollThreshold) {
      return;
    }
    // make sure scrolling functions are enabled, else cancel
    if (enableScrollFunctions == 0) {
      return;
    }
    // if scrolled down
    if (prevScrollPosition < scrollPosition && enableScrollFunctions == 1) {
      // show/hide any elements that are set to do so on scroll down, and adjust positions of related elements
      scrollShowHides("down");
      backToTop("down");
      headerHeightHandler();
    }
    // if scrolled up
    else if (prevScrollPosition > scrollPosition && enableScrollFunctions == 1) {
      headerHeightHandler();
      if (scrollPosition + $(window).height() < $(document).height()) {
        // scrolled to "top" (from zero to minimum height of fixed header)
        if (scrollPosition < headerHeightScrollDown) {
          // show/hide any elements that are set to do so on scroll to top, and adjust positions of related elements
          scrollShowHides("top");
        }
        // just scrolled up some, but not all the way to top
        else {
          // show/hide any elements that are set to do so on scroll up, and adjust positions of related elements
          scrollShowHides("up");
          backToTop("up");
        }
      }
    }
    subnavActive();

    //setTimeout( $(".msg").text(scrollPosition), animationSpeed+50 );

    // mark current position as previous to prepare for further scrolling
    prevScrollPosition = scrollPosition;
  }

  // FUNCTION : handle scroll-based show/hides
  function scrollShowHides(direction) {
    if ($("body").hasClass("desktop")) {
      // scrolling down
      if (direction == "down") {
        // check if the entire header is meant to hide, and if so only do this if scrolled past header; otherwise just allow 100 px margin from top before activating
        if ($(".header").hasClass("desktop-scroll-down-hide") && scrollPosition > headerHeightAtTop || !$(".header").hasClass("desktop-scroll-down-hide") && scrollPosition > 100) {
          // hide/slide up each scroll-down-hide element
          $(".desktop-scroll-down-hide:visible").each(function () {
            $(this).slideUp(animationSpeedSlow, "swing");
            // hide any custom search overlays inside this element and switch any toggles to close
            $(this).find(".custom-search").hide();
            $(this).find(".search-toggle.search-close").addClass("search-open");
            $(this).find(".search-toggle.search-close").removeClass("search-close");
          });
          // adjust top-sticky positions to account for height of header when scrolled down
          setTopStickyTops(headerHeightScrollDown);
        }
      }
      // scrolled to top of page
      else if (direction == "top") {
        // show/slide down each scroll-top-show element
        $(".desktop-scroll-top-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // show/slide down each scroll-up-show element
        $(".desktop-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when at top of page
        setTopStickyTops(headerHeightScrollTop);
      }
      // scrolled up a certain amount but not to top of page
      else if (direction == "up") {
        // show/slide down each scroll-up-show element
        $(".desktop-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // if you're scrolling up, but top-only elements are visible, i.e. on page load, where the whole header is reset
        $(".desktop-scroll-top-show:visible").each(function () {
          $(this).slideUp(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when scrolled up some amount
        setTopStickyTops(headerHeightScrollUpSome);
      }
    } else if ($("body").hasClass("mobile")) {
      // scrolling down
      if (direction == "down") {
        // check if the entire header is meant to hide, and if so only do this if scrolled past header; otherwise just allow 100 px margin from top before activating
        if ($(".header").hasClass("mobile-scroll-down-hide") && scrollPosition > headerHeightAtTop || !$(".header").hasClass("mobile-scroll-down-hide") && scrollPosition > 100) {
          // hide/slide up each scroll-down-hide element
          $(".mobile-scroll-down-hide:visible").each(function () {
            $(this).slideUp(animationSpeedSlow, "swing");
          });
          // adjust top-sticky positions to account for height of header when scrolled down
          setTopStickyTops(headerHeightScrollDown);
        }
      }
      // scrolled to top of page
      else if (direction == "top") {
        // show/slide down each scroll-top-show element
        $(".mobile-scroll-top-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // show/slide down each scroll-up-show element
        $(".mobile-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when at top of page
        setTopStickyTops(headerHeightScrollTop);
      }
      // scrolled up a certain amount but not to top of page
      else if (direction == "up") {
        // show/slide down each scroll-up-show element
        $(".mobile-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // if you're scrollin up, but top-only elements are visible, i.e. on page load, where the whole header is reset
        $(".mobile-scroll-top-show:visible").each(function () {
          $(this).slideUp(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when scrolled up some amount
        setTopStickyTops(headerHeightScrollUpSome);
      }
    }
  }

  // FUNCTION : set top values for any visible top-sticky elements
  function setTopStickyTops(topStickyBasis) {
    // start by adjusting the top value by some base amount, usually the predicted height of the header after a given scroll
    var topStickyTop = topStickyBasis;
    // for each visible top-sticky element, set the new top amount to equal the base amount, then increment the base amount by the height of the element that was just handled
    $(".top-sticky:visible").each(function () {
      if ($(this).css("position") == "sticky") {
        $(this).css({
          "top": topStickyTop
        });
        scrollPositionOffset = topStickyTop;
        topStickyTop = topStickyTop + $(this).outerHeight();
      }
    });
  }

  // FUNCTION : show/hide the custom search bar
  function searchShowHide(target) {
    if ($(target).hasClass("search-open")) {
      if ($(target).hasClass("search-toggle")) {
        $(target).removeClass("search-open");
        $(target).addClass("search-close");
      }
      if ($(target).closest(".header-search").hasClass("slide-down")) {
        $(target).closest(".header-search").find(".custom-search").slideDown('fast');
      }
      if ($(target).closest(".header-search").hasClass("slide-left")) {
        $(target).closest(".header-search").find(".custom-search").animate({
          width: "100%"
        }, animationSpeed, function () {});
      }
    } else if ($(target).hasClass("search-close")) {
      if ($(target).hasClass("search-toggle")) {
        $(target).removeClass("search-close");
        $(target).addClass("search-open");
      }
      if ($(target).closest(".header-search").hasClass("slide-down")) {
        $(target).closest(".header-search").find(".custom-search").slideUp('fast');
      }
      if ($(target).closest(".header-search").hasClass("slide-left")) {
        $(target).closest(".header-search").find(".custom-search").animate({
          width: "0"
        }, animationSpeed, function () {});
      }
    }
  }

  // FUNCTIONS: these two functions swap show/hide text pairs
  function showHideTogglesOpened(thisObj) {
    if (thisObj.hasClass('view-close')) {
      thisObj.html('Close');
    }
    if (thisObj.hasClass('show-hide')) {
      thisObj.html('Hide');
    }
    if (thisObj.hasClass('more-less')) {
      thisObj.html('less');
    }
    if (thisObj.hasClass('right-down')) {
      thisObj.children('img').css({
        'transform': 'rotate(90deg)'
      });
    }
    if (thisObj.hasClass('plus-minus')) {
      thisObj.html('&ndash;');
    }
    if (thisObj.hasClass('expand-close')) {
      thisObj.html('Close [&nbsp;&ndash;&nbsp;]');
    }
    if (thisObj.hasClass('plus-minus-brackets')) {
      thisObj.html('[&nbsp;&ndash;&nbsp;]');
    }
  }
  function showHideTogglesClosed(thisObj) {
    if (thisObj.hasClass('view-close')) {
      thisObj.html('View');
    }
    if (thisObj.hasClass('show-hide')) {
      thisObj.html('Show');
    }
    if (thisObj.hasClass('more-less')) {
      thisObj.html('more');
    }
    if (thisObj.hasClass('right-down')) {
      thisObj.children('img').css({
        'transform': 'rotate(0deg)'
      });
    }
    if (thisObj.hasClass('plus-minus')) {
      thisObj.html('+');
    }
    if (thisObj.hasClass('expand-close')) {
      thisObj.html('Expand [&nbsp;+&nbsp;]');
    }
    if (thisObj.hasClass('plus-minus-brackets')) {
      thisObj.html('[&nbsp;+&nbsp;]');
    }
  }

  // FUNCTION : set subnav items active or not based on scroll position
  function subnavActive() {
    // set a brief timeout so that this doesn't trigger until all scrolling/animating has completed - if this fires too early the numbers will be variable
    setTimeout(function () {
      // get the new adjusted scroll position by adding the offset value from the top-sticky function to the actual scroll position
      offsetScrollPosition = scrollPosition + scrollPositionOffset;
      // for each visible subnav link, get the HREF value; if value exists, define the top and bottom boundaries of that section. If adjusted scroll position falls between those boundaries, set that subnav link to .active, otherwise remove .active.
      $(".subnav a:visible").each(function () {
        theSubnavHREF = $(this).attr("href");
        if ($(theSubnavHREF).length != 0) {
          theSectionTop = $(theSubnavHREF).offset().top;
          theSectionHeight = $(theSubnavHREF).outerHeight();
          theSectionBottom = theSectionTop + theSectionHeight;
          if (offsetScrollPosition >= theSectionTop && offsetScrollPosition < theSectionBottom) {
            $(this).addClass("active");
          } else {
            $(this).removeClass("active");
          }
        }
      });
    }, 10);
  }

  // FUNCTION : resize scrollable tables
  function tableScrolling() {
    $('.table-container').each(function () {
      var tableContHeight = $(this).children('table').outerHeight() + 20;
      $(this).css("height", tableContHeight);
      $(this).addClass('scrollable');
    });
  }

  // -------------------- END CALLABLE FUNCTIONS --------------------

  // MOVE THIS: Move things from one area to another on mobile-desktop switch
  // Instructions: give the item you want to move the '.moveThis' class and an ID. 
  // Give the two alternating containers the same ID with -desktop and - mobile appended.
  function moveThisFunctions() {
    $('.moveThis').each(function () {
      var moveTargetID = $(this).attr('id');
      // Mobile
      if ($('body').css('max-width') === '9999px') {
        if ($('#' + moveTargetID + '-mobile #' + moveTargetID + '').length === 0) {
          $('#' + moveTargetID + '').appendTo(jQuery('#' + moveTargetID + '-mobile'));
        }
      }
      // Desktop
      else {
        if ($('#' + moveTargetID + '-desktop #' + moveTargetID + '').length === 0) {
          $('#' + moveTargetID + '').appendTo(jQuery('#' + moveTargetID + '-desktop'));
        }
      }
    });
  }
})(jQuery);